import React, { useEffect, useState } from "react";
import PageRoutes from "./PageRoutes";
import { useSelector, useDispatch } from "react-redux";
import { getAuthUsers, refreshUser } from "./store/actions";
import Spinner from "./component/common/loading";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "./store/actions";

function App() {
  const [lastActivity, setLastActivity] = useState(Date.now());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuth, isLoading } = useSelector((state) => state.auth);
  const { users } = useSelector((state) => state.user_profile);

  const handleLogout = (e) => {
    localStorage.clear();
    dispatch(refreshUser());
  };

  useEffect(() => {
    const tokenString = localStorage.getItem("token");
    if (tokenString) {
      dispatch(refreshUser());
      dispatch(getAuthUsers());
    } else {
      dispatch(refreshUser());
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    const excludedPaths = ["/login", "/register-user", "/kyc", "/forgot-password", "/congrates", "/reset-password", "/email-verification/success", "/register-company"];
    const isExcludedPath = excludedPaths.includes(location.pathname);

    if (!isExcludedPath) {
      const intervalId = setInterval(() => {
        const now = Date.now();
        const elapsedTime = now - lastActivity;
        const minutesSinceActivity = Math.floor(elapsedTime / (1000 * 60));

        if (minutesSinceActivity >= 10 && !isLoading && isAuth) {
          handleLogout();
        }
      }, 1000);

      return () => clearInterval(intervalId);
    }
  }, [location.pathname, isLoading, isAuth]);

  // useEffect(() => {
  //   let current_url = window.location.href;
  //   if (current_url.includes('https://api-rosabon.optisoft.com.ng:8090/payment/callback')) {
  //     let url_split = current_url.split('=')
  //     localStorage.setItem('trxref', url_split[2])
  //     navigate("/create-plan")
  //   }
  // },[])

  const handleUserActivity = () => {
    setLastActivity(Date.now());
  };

  return (
    <div className="App" onMouseMove={handleUserActivity} onClick={handleUserActivity}>
      {
        isAuth !== null ? (
          <PageRoutes setLastActivity={setLastActivity} login={login} isAuth={isAuth} user={users} />
        ) :
          (
            <div className="vh-100 w-100" >
              <Spinner />
            </div>
          )
      }

    </div>
  );
}

export default App;
